namespace advisorop.components.advisor {
    

    class AccountLookupController {
        public accountResult: domains.ISearchAccountResults;
        formDataChanged: any;
        openOnly: boolean;
        
        accountType?: number;

        static $inject = ["advisorService", "$filter", "$rootRouter"];
        constructor(private advisorService: services.AdvisorService,
            public $filter,
            public $rootRouter) {        
        }
        
        searchItems(searchTerm: string): ng.IPromise<Array<{}>> {
            //console.log("ACCOUNT TYPE:", this.accountType);
            if (this.openOnly == true) {
                return this.advisorService.searchOpenAccounts(searchTerm, this.accountType).then((response) => {
                    return response.data;
                });
            } else {
                return this.advisorService.searchAccounts(searchTerm, this.accountType).then((response) => {
                    return response.data;
                });
            }
        }

        onSelectItem(item, model, label, event): void {
            this.accountResult = item;
        }
      
        inputChanged() {
            // callback to calling controller
            this.formDataChanged();
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {            
        }
    }

    //title 3 types indvidual , joint more than one, custodian 
    class AccountLookup implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.controller = AccountLookupController;
            this.controllerAs = "vm";
            this.bindings = {
                formDataChanged: "&",
                accountResult: "=",
                accountType: "<",
                openOnly: "<"
            };
            this.templateUrl = "spa/advisor-module/components/account-lookup.html";
        }

    }
    angular.module(Constants.APP).component("accountLookup", new AccountLookup());
}